<template>
  <div>
    <v-card class="card" :max-width="this.width">
      <v-img v-if="isImage(postData.imageLinks[0])" class="white--text align-end" :width="this.width" :src="postData.imageLinks[0]"></v-img>
      <video v-else class="white--text align-end" :width="this.width" :src="postData.imageLinks[0]" autoplay loop muted></video>
      <div class="accent-line"></div>
      <div class="card-title">{{postData.title}}</div>

      <v-card-actions>
        <span class="dot"></span>
        <div class="active-count">
          <span class="bolded">{{postData.liveCount}}</span>
          <span> live</span>
        </div>
        <v-spacer></v-spacer>
        <div class="tags">
          <v-chip small color="#3a3a3a" class="tag" v-for="tag in postData.tags" :key="tag">{{tag}}</v-chip>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import isImage from 'is-image';
export default {
  name: "PreviewCard",
  methods: {
    isImage
  },
  props: {
    postData: {},
    width: {type: String, default: '251'}
  },
  data: () => ({}),
};
</script>


<style scoped>
.card {
  margin: 5px;
  cursor: pointer;
  transition: background-color 200ms;
}
.card:hover {
  transition: background-color 200ms;
  background-color: #333;
}
.card-title {
  font-size: .9rem;
  letter-spacing: 0.2px;
  margin: 5px 10px 2px 10px;
}
.icon {
  font-size: 10px;
}
.active-count {
  font-size: 0.8rem;
}
.accent-outline {

}
.dot {
  height: 10px;
  width: 10px;
  margin-right: 5px;
  animation: flashing-green 2s infinite;
  background-color: rgb(51, 253, 0);
  border-radius: 50%;
  display: inline-block;
}
@keyframes flashing-green {
  0% {
    background-color: rgba(51, 253, 0, 0.4);
  }
  50% {
    background-color: rgb(51, 253, 0);
  }
  100% {
    background-color: rgba(51, 253, 0, 0.4);
  }
}
.bolded {
  font-weight: 800;
}
.tags {
}
.tag {
  margin: 0 2.5px 0 2.5px;
}
</style>